module.exports = __webpack_public_path__ + "content/7f690e503a254e0b8349aec0177e07aa.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/fonts/lato-regular.ttf
// module id = 125
// module chunks = 2